<template>
    <div class="consultation-list">
        <span v-if="callToCheck !== null && moment(callToCheck.date).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')" class="btn-consultation-wrapper">
            <input :id="'event-'+callToCheck.coach_task_id" type="checkbox" name="task-checkbox" :data-id="callToCheck.coach_task_id">
            <label class="btn-consultation btn-consultation-check tooltip tooltip-hover" @click="markCompleted($event, callToCheck.coach_task_id)">
                <span class="material-icons">done</span>

                <div class="tooltip-content content-width right"><p>{{ __('The consultation took place') }}</p></div>
            </label>
            <button type="button" class="btn-consultation btn-consultation-cancel tooltip tooltip-hover" data-target="#task-consultation-cancel-modal" data-toggle="modal" :data-id="callToCheck.coach_task_id" @click="setCancelTaskId">
                <span class="material-icons">close</span>

                <div class="tooltip-content content-width right"><p>{{ __('Cancel consultation') }}</p></div>
            </button>
        </span>

        <ul v-else>
            <li v-for="(call, index) in call_list" :key="index"  :class="'tooltip consultation-status consultation-'+call.status">
                <i></i>
                <span class="tooltip-content content-width right"><p>{{ getTooltip(call) }}</p></span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        call_list: {
            type: Array,
            required: true
        }
    },
    
    data() {
        return {
            callToCheck: null
        }
    },

    mounted() {
        setTimeout(() => {
            if(!this.impersonatorOrUser.isDoctor) {
                this.setTaskId()
            }
        }, 50);
    },

    computed: {
        
    }, 

    methods: {
        getTooltip(call) {
            switch (call.status) {
                case "done":
                    return lang.get("[call status] Done")
                case "next":
                    return lang.get("Upcoming")
                case "canceled":
                    return lang.get("Rejected ")
                case "task":
                    return lang.get("Task on booking")
                case "postponed":
                    return lang.get("Postponed")
                case "reserved":
                    var date = call.date
                    var dateString = moment(date).fromNow()

                    if(moment(date).isSame(moment(), 'day')) {
                        dateString = lang.get("Today") + " " + moment(date).format("H:mm")
                    }

                    if(moment(date).isSame(moment().add(1, 'day'), 'day')) {
                        dateString = lang.get("Tomorrow") + " " + moment(date).format("H:mm")
                    }

                    return lang.get("Booked")+" (" + dateString + ")"
                default:
                    break
            }
        },

        markCompleted(event, id) {
            var that = this

            axios.put('/muj-panel/tasks/mark-completed', { task_id: id })
                .then(() => {
                    that.callToCheck = null
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },

        setTaskId() {
            var that = this
            this.call_list.forEach(call => {
                if(call.coach_task_id !== null) {
                    that.callToCheck = call
                    that.$forceUpdate;
                }
            })
        },

        setCancelTaskId() {
            const form = document.getElementById('task-consultation-cancel-form');
            form.setAttribute('action', `/tasks/${this.callToCheck.coach_task_id}/consultation/cancel`);
        }
    }
}
</script>
